<template>
  <v-layout column escalon-absolute-cover>
    <v-flex tall-content-wrapper patient-list-wrapper>
      <v-data-table
        :headers="headers"
        :items="patients"
        :server-items-length="totalPatients"
        :options.sync="options"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        :loading="loadingPatients"
        sort-by="lastName"
        :sort-desc="false"
        group-by="exDateIso"
        :group-desc="true"
        item-key="tableKey"
        hide-default-footer
        @page-count="pageCount = $event"
        class="primary"
        style="margin-right: 0px;margin-left: 0px;"
        ref="table">
        <template slot="group" slot-scope="props">
          <tr class="v-row-group__header" :class="colorClass" @click="toggleGroup(props.group)">
            <td class="font-weight-bold" colspan="3">
              <v-icon size="15" v-if="isClosed(props.group)">fas fa-chevron-down</v-icon>
              <v-icon size="15" v-else>fas fa-chevron-up</v-icon>
              {{ props.items[0].exDateDisplay }} ({{ props.items.length }} {{ props.items.length == 1 ? "visit" : "visits"}})
            </td>
          </tr>
          <tr
            v-for="item in props.items"
            :key="item.tableKey"
            @click="selectPatient(item)"
            :class="{'selectedPatient': isActive(item.ptId), 'd-none':isClosed(props.group)}">
            <td>{{item.ptId}}</td>
            <td>{{ item.lastName }}</td>
            <td>{{ item.firstName }}</td>
          </tr>
        </template> 
      </v-data-table>
    </v-flex>
    <v-flex text-xs-center pt-2 shrink>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :color="colorHex"
        prev-icon="fas fa-caret-left"
        next-icon="fas fa-caret-right"></v-pagination>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { logDetailed } from "../../helpers/utils";

export default {
  name: "PatientListTable",
  data() {
    return {
      headers: [
        {
          text: "PATIENT ID",
          align: "left",
          value: "ptId"
        },
        {
          text: "LAST NAME",
          align: "left",
          value: "lastName"
        },
        {
          text: "FIRST NAME",
          align: "left",
          value: "firstName"
        }
      ],
      page: 1,
      pageCount: 0,
      selectedPtId: 0,
      closedGroups: {},
      options: {}
    };
  },
  computed: {
    ...mapGetters(["loadingPatients", "patients", "totalPatients", "searchTimespan", "userPrefs"]),
    itemsPerPage() {
      return (this.userPrefs.pageSize == null) ? 25 : this.userPrefs.pageSize
    }
  },
  methods: {
    isActive(ptId) {
      return ptId == this.selectedPtId;
    },
    selectPatient(patient){
      this.$store.dispatch("selectPatient", patient);
      this.selectedPtId = patient.ptId;
    },
    toggleGroup(group){
      if (!this.closedGroups.hasOwnProperty(group)){
        this.$set(this.closedGroups, group, false);
      }
      this.closedGroups[group] = !this.closedGroups[group];
    },
    isClosed(group){
      return this.closedGroups[group];
    }
  },
  watch: {
    options: {
      handler(){  
        logDetailed("PatientListTable", "watch:options", this.options);
        this.$store.commit("updatePatientSearchOptions", this.options);
         // if getPatients is triggered by other function, no need to trigger it here again. EX. submitQuickSearch
        if (this.loadingPatients) return;
        this.$store.dispatch("getPatients");
      },
      deep: true
    },
    searchTimespan() {
      this.page = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.selectedPatient {
  background: #616161;
}
.patient-list-wrapper {
  overflow: auto;
}
</style>